import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';

const generateWrapperClassNames = ({ extraClass }) =>
  classNames('accordion__item', extraClass);

// istanbul ignore next
class AccordionItem extends React.Component {
  constructor(props) {
    super(props);

    const {
      children, isOpen, toggle, id, index,
    } = props;

    this.childKeys = React.Children.toArray(children).map(() => uuid());

    if (isOpen) {
      toggle(id, index);
    }
  }

  render() {
    const {
      children, id, extraClass, index: itemIndex,
    } = this.props;

    return (
      <div className={generateWrapperClassNames({ extraClass })}>
        {React.Children.toArray(children).map((child, index) =>
          React.cloneElement(child, {
            key: this.childKeys[index],
            index: itemIndex,
            id,
          }))}
      </div>
    );
  }
}

AccordionItem.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  index: PropTypes.number,
  extraClass: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};

export default AccordionItem;
